var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { staticClass: "quantity-editor" },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("FinanceManage.Quantity") } },
            [
              _c("el-input", {
                staticStyle: { width: "100px" },
                attrs: { size: "mini" },
                on: { change: _vm.quantityChangeHandler },
                model: {
                  value: _vm.form.quantity,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "quantity", $$v)
                  },
                  expression: "form.quantity"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("FinanceManage.UnitPrice") } },
            [
              _c("el-input", {
                staticStyle: { width: "100px" },
                attrs: { size: "mini" },
                on: { change: _vm.priceChangeHandler },
                model: {
                  value: _vm.form.price,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "price", $$v)
                  },
                  expression: "form.price"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }